import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {Router} from '@angular/router';
import {CartService} from '../cart.service';
import { ApiService } from '../api.service';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-event-site',
  template: `
      <nav class="navbar navbar-light navbar-expand-lg">
          <a class="navbar-brand" routerLink="/home" >
              <img src="assets/images/mdvip.svg" alt="MDVIP" height="36px;"/>
              <img [src]="logoUrl" alt="logo" *ngIf="false" height="50px"/>
          </a>
          <ul class="navbar-nav ml-auto" *ngIf="user">
              <li class="nav-item mx-lg-2" *ngIf="cartLines > 0"><a class="nav-link" routerLink="/cart">
                  <i class="fa fa-shopping-cart"></i> Cart ({{cartLines}})</a></li>
              <li class="nav-item mx-lg-2" *ngIf="isApprover && false">
                  <a class="nav-link" href="https://form.jotform.com/200555737800150" target="_blank">Image Upload</a></li>
              <li class="nav-item mx-lg-2" *ngIf="isApprover"><a class="nav-link" routerLink="/approval">Approval</a></li>
              <li class="nav-item mx-lg-2" *ngIf="isApprover"><a class="nav-link" routerLink="/crm-report">CRM Report</a></li>
              <li class="nav-item mx-lg-2"><a class="nav-link" routerLink="/history">Order History</a></li>
              <li class="nav-item mx-lg-2" ngbDropdown>
                  <a class="nav-link" style="cursor: pointer" ngbDropdownToggle id="userDropdown" role="button">
                      {{firstname}} {{lastname}}
                  </a>
                  <div ngbDropdownMenu aria-labelledby="userDropdown" class="dropdown-menu dropdown-menu-right">
                      <button class="dropdown-item" ngbDropdownItem (click)="logout($event)">Logout</button>
                  </div>
              </li>
          </ul>
      </nav>
      <router-outlet></router-outlet>
  `,
  styleUrls: ['./event-site.component.scss']
})
export class EventSiteComponent implements OnInit, OnDestroy {
  firstname = '';
  lastname = '';
  private subscription: Subscription;
  private logoUrl = '';
  private isApprover = false;
  private cartLines = 0;
  user: any = null;

  constructor(private apiService: ApiService, private authService: AuthService,
              private router: Router, private cartService: CartService) {}
  async ngOnInit() {
    this.subscription = new Subscription();

    const isAuthenticatedSubscription = this.authService.authState.subscribe(async isAuthenticated => {
      if (isAuthenticated) {
        this.user = await this.apiService.getUser().toPromise();
        if (this.user) {
          this.isApprover = this.user.isAdmin;
          if (this.user.physician) {
            this.firstname = 'Dr.';
            this.lastname = this.user.physician.lastname;
          } else {
            this.firstname = '';
            this.lastname = this.user.username;
          }
        }
      } else {
        this.user = null;
        this.isApprover = false
        this.firstname = '';
        this.lastname = '';
        this.router.navigate(['/login']);
      }
    });
    this.subscription.add(isAuthenticatedSubscription);
    
    const cartSubscription = this.cartService.cartObservable().subscribe(cart => {

      if (cart) {
        this.cartLines = cart.placeOrderLines.length;
      } else {
        this.cartLines = 0;
      }
    });
    this.subscription.add(cartSubscription);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  logout(e) {
    e.preventDefault();
    this.authService.setToken(null);
  }
}
